import React from "react";

const SALLIE_LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_tracey-hub/artifacts/iagfj8ws_Sallie%20Sells%20Real%20Estate%20%283%29.png";

/**
 * Tasteful, secondary creator credit.
 * Sits under the primary GK Team branding — small, muted, never competes visually.
 *
 * variant="sidebar"  — very small footer, single line, low-contrast text
 * variant="login"    — slightly larger for the sign-in page, centered
 */
export default function PoweredBy({ variant = "sidebar", className = "" }) {
  const isLogin = variant === "login";
  const wrap = isLogin
    ? "flex items-center justify-center gap-2 opacity-80"
    : "flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity";
  const label = isLogin ? "text-[11px] tracking-[0.18em]" : "text-[10px] tracking-[0.16em]";
  const img = isLogin ? "w-8 h-8" : "w-6 h-6";
  return (
    <div className={`${wrap} ${className}`} data-testid={`powered-by-${variant}`} aria-label="Powered by Sallie Sells Real Estate">
      <img
        src={SALLIE_LOGO}
        alt="Sallie Sells Real Estate"
        className={`${img} rounded-full object-cover shrink-0`}
        draggable={false}
      />
      <div className={`${label} uppercase text-ink-soft leading-tight`}>
        <div className="text-[9px] text-ink-soft/70 tracking-[0.22em]">Powered by</div>
        <div className="font-medium text-gk-charcoal normal-case tracking-normal text-[12px] leading-tight">
          Sallie Sells Real Estate
        </div>
      </div>
    </div>
  );
}
